import React, { useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './VideoPlayer.css';

const VideoPlayer: React.FC = () => {
  const navigate = useNavigate();
  const { id, chapterId, videoId } = useParams();
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(630); // 10:30 in seconds
  const [showControls, setShowControls] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);

  // Mock data
  const video = {
    id: 1,
    title: 'What is Calculus?',
    description: 'Introduction to the fundamental concepts of calculus',
    duration: '10:30',
    isWatched: false
  };

  const videos = [
    { id: 1, title: 'What is Calculus?', duration: '10:30' },
    { id: 2, title: 'Understanding Limits', duration: '15:45' },
    { id: 3, title: 'Introduction to Derivatives', duration: '12:20' },
    { id: 4, title: 'Basic Derivative Rules', duration: '18:10' }
  ];

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleSeek = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTime = parseFloat(e.target.value);
    if (videoRef.current) {
      videoRef.current.currentTime = newTime;
      setCurrentTime(newTime);
    }
  };

  const handleVideoClick = (newVideoId: number) => {
    navigate(`/course/${id}/chapter/${chapterId}/video/${newVideoId}`);
  };

  return (
    <div className="video-player-page">
      {/* Video Container */}
      <div 
        className="video-container"
        onMouseEnter={() => setShowControls(true)}
        onMouseLeave={() => setTimeout(() => setShowControls(false), 3000)}
      >
        <div className="video-wrapper">
          {/* Watermark - Simulated */}
          <div className="video-watermark">Student Name</div>
          
          {/* Video Element - Placeholder */}
          <div className="video-placeholder">
            <div className="video-placeholder-content">
              <div className="play-icon-large" onClick={handlePlayPause}>
                {isPlaying ? '⏸' : '▶'}
              </div>
              <p>Video Player</p>
              <p className="video-placeholder-note">DRM Protected Content</p>
            </div>
          </div>

          {/* Video Controls */}
          {showControls && (
            <div className="video-controls">
              <div className="progress-bar-container">
                <input
                  type="range"
                  min="0"
                  max={duration}
                  value={currentTime}
                  onChange={handleSeek}
                  className="progress-slider"
                />
              </div>
              <div className="controls-bottom">
                <div className="controls-left">
                  <button className="control-button" onClick={handlePlayPause}>
                    {isPlaying ? '⏸' : '▶'}
                  </button>
                  <span className="time-display">
                    {formatTime(currentTime)} / {formatTime(duration)}
                  </span>
                </div>
                <div className="controls-right">
                  <button className="control-button">🔊</button>
                  <button className="control-button">⛶</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Video Info */}
      <div className="video-info-section">
        <button className="back-button-top" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <h1 className="video-title-large">{video.title}</h1>
        <p className="video-description">{video.description}</p>
      </div>

      {/* Videos List */}
      <div className="videos-list-section">
        <h2 className="section-title">Course Videos</h2>
        {videos.map((vid) => (
          <div
            key={vid.id}
            className={`video-list-item ${parseInt(videoId || '0') === vid.id ? 'active' : ''}`}
            onClick={() => handleVideoClick(vid.id)}
          >
            <div className="video-thumbnail">▶</div>
            <div className="video-list-info">
              <h3>{vid.title}</h3>
              <span className="video-list-duration">{vid.duration}</span>
            </div>
            {parseInt(videoId || '0') === vid.id && (
              <span className="playing-indicator">●</span>
            )}
          </div>
        ))}
      </div>

      <BottomNavigation />
    </div>
  );
};

export default VideoPlayer;
